export const initial = window.location.hash.replace(/^#/, '');

export function to(state, payload) {
    return payload;
}

export const hashchanged = to;



// WEBPACK FOOTER //
// ./app/reducers/route.js